module.exports = __webpack_public_path__ + "img/tooltip_02-vallone-lax-perla.7085a98d.jpg";